<template>
    <v-container>
        <v-card-title>

            <!-- boton + modal para crear un trs -->
            <CreateOrderTransport :id="order.id" v-on:created="getOrderTransports()"></CreateOrderTransport>

            <!-- input de busqueda -->
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>

        </v-card-title>

        <!-- tabla -->
        <v-data-table
                :headers="headers"
                :items="products.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs">{{ props.item.trs_code }}</td>
                <td class="text-xs">{{ props.item.trs_description }}</td>
                <td class="text-xs">{{ props.item.trs_quantity }}</td>
                <td class="text-xs">{{ props.item.trs_unit_price }}</td>
                <td class="text-xs">{{ props.item.trs_total_price }}</td>
                <td class="text-xs">{{ props.item.trs_vat }}</td>
                <td class="layout px-0 align-center">
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                            left
                    >
                        <v-btn
                                slot="activator"
                                color="primary"
                                dark
                                fab
                                flat
                        >
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile>
                                <EditOrderTransport :id="order.id" :transport="props.item" v-on:created="getOrderTransports()"></EditOrderTransport>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>delete</v-icon>Delete</v-btn>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="products.data">
            <v-pagination
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
            <p class="subtitle">Showing {{ products.meta.from }} to {{ products.meta.to }} of {{ products.meta.total }} entries</p>
        </div>


        <!--
            <v-layout column>
                <v-flex>
                    <vue-editor v-model="order.text"></vue-editor>
                </v-flex>
                <v-flex>
                    <v-btn color="secondary" class="text--primary" @click="saveText()">Save</v-btn>
                </v-flex>
            </v-layout>
        -->
    </v-container>
</template>

<script>
    import CreateOrderTransport from './components/CreateOrderTransport';
    import EditOrderTransport from './components/EditOrderTransport';
    import { DICCIONARIO } from '../../../../diccionario';
    import { VueEditor } from "vue2-editor";

    export default {
        props: ['order'],
        data: function () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                headers: [
                    {
                        text: 'Code',
                        align: 'left',
                        sortable: false,
                        value: 'trs_code'
                    },
                    { text: 'Description', value: 'trs_description', sortable: false },
                    { text: 'Quantity', value: 'trs_quantity', sortable: false },
                    { text: 'Unit price', value: 'trs_unit_price', sortable: false },
                    { text: 'Total price', value: 'trs_total_price', sortable: false },
                    { text: 'Vat', value: 'trs_vat', sortable: false },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                products: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
            }
        },
        created () {
            this.getOrderTransports();
            this.debouncedGetProducts = _.debounce(this.getOrderTransports, 500)
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetProducts();
            },
            last_page: function () {
                if (this.page > this.products.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods: {
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteOrderTransport', {
                            id: this.order.id,
                            transport_id: id
                        }).then((res) => {
                            this.getOrderTransports()
                        }).catch((error) => {

                        });
                    }
                })
            },
            setPage (page) {
                this.page = page;
                this.getOrders();
            },
            getOrderTransports () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        id: this.order.id
                    },
                    id: this.order.id
                };
                this.$store.dispatch('getOrderTransports', params).then((res) => {

                    this.products = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            saveText () {
                this.$store.dispatch('saveAdditionalText', {
                    id: this.order.id,
                    text: this.order.text
                }).then((res) => {

                    this.$store.dispatch('setSnackBarText', {
                        text: 'Order confirmation commented successfully.'
                    });
                    this.$store.dispatch('activeSnack')
                    this.$emit('update');

                }).catch((error) => {

                });
            }
        },
        components: {
            CreateOrderTransport,
            EditOrderTransport,
            VueEditor
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/orders/views/TrsComponent.vue